import { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import {
  buildPanelPath,
  parseSttokHref,
} from 'modules/ai/utils/resolveAiPanelLink';

type AiMarkdownLinkProps = {
  href?: string;
  children?: ReactNode;
  societyId: string;
};

const AiMarkdownLink: FC<AiMarkdownLinkProps> = ({
  href,
  children,
  societyId,
}) => {
  const sttokLink = parseSttokHref(href);

  if (sttokLink) {
    const path = buildPanelPath(sttokLink.routeId, { societyId });
    if (path) {
      return (
        <Link to={path} className="navi-panel-link">
          <em className="icon ni ni-link navi-panel-link__icon" aria-hidden />
          <span className="navi-panel-link__text">{children}</span>
        </Link>
      );
    }
    return <span>{children}</span>;
  }

  // eslint-disable-next-line no-script-url
  if (!href || href.startsWith('javascript:')) {
    return <span>{children}</span>;
  }

  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  );
};

export default AiMarkdownLink;
